import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AbstractPresetListComponent } from '../../preset-list.component';
import { EventBus } from '../../../../../shared/event/bus';
import { BreadcrumbBuilder } from '../../../../../shared/ui/breadcrumb/breadcrumb-builder';
import { AdminUrlBuilder } from '../../../../../shared/admin/api/admin-url-builder';

@Component({
  selector: 'admin-photocode-template-list',
  templateUrl: './list.component.html',
  styleUrls: [ './list.component.scss' ]
})
export class AdminPhotocodeTemplateListComponent extends AbstractPresetListComponent implements OnInit {

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              urlBuilder: AdminUrlBuilder,
              eventBus: EventBus,
              changeDetector: ChangeDetectorRef,
              private breadcrumbBuilder: BreadcrumbBuilder) {
    super(httpClient, toastrService, router, route, urlBuilder, eventBus, changeDetector);
  }

  getResourceUrl(): string {
    return '/photocode-template';
  }

  ngOnInit(): void {
    this.breadcrumbBuilder.clear();
    this.breadcrumbBuilder.add({
      label: 'Admin / Photocode template',
      url: '/admin/photocode-template'
    });

    super.ngOnInit();
  }

  add() {
    this.pagination.rows.push({
      __editing: true,
      name: `Photocode template #${this.pagination.count + 1}`
    });
  }

  setDefault(row) {
    const url = this.urlBuilder.buildUrl(`${this.getResourceUrl()}/${row.id}/default`);
    this.httpClient.put(url, {
      isDefault: !row.isDefault
    }).subscribe((response: any) => {
      row.isDefault = response.isDefault;
      this.toastrService.success('Saved');
      this.load();
      return response;
    }, (error: any) => {
      this.toastrService.error(error.message);
      return error;
    });
  }
}
